import { TextEditor } from '@approvalmax/ui';
import { forwardRef, memo, useCallback } from 'react';
import { Props } from 'react-phone-number-input/input';

import { PhoneInputComponentProps } from './PhoneInputComponent.types';

const PhoneInputComponent = memo(
    forwardRef<HTMLInputElement, PhoneInputComponentProps>((props, ref) => {
        const { className, smartCaretDisabled, value, invalid, placeholder, theme, name, onChange, onFocus, onBlur } =
            props;

        const handleChange = useCallback(
            (value: string) => {
                if (smartCaretDisabled) {
                    // InputBasic read value from event.target.value
                    // https://gitlab.com/catamphetamine/react-phone-number-input/-/blob/master/source/InputBasic.js#L36
                    onChange({
                        target: { value },
                    } as any);
                } else {
                    onChange(value as Parameters<NonNullable<Props<Record<string, any>>['onChange']>>[0]);
                }
            },
            [smartCaretDisabled, onChange]
        );

        return (
            <TextEditor
                className={className}
                onChange={handleChange}
                onFocus={onFocus}
                onBlur={onBlur}
                value={value ?? ''}
                spellCheck={false}
                ref={ref}
                type='tel'
                invalid={invalid}
                placeholder={placeholder}
                theme={theme}
                name={name}
                autoComplete='off'
                data-1p-ignore
            />
        );
    })
);

export default PhoneInputComponent;
